export default class MassiaNavigationController {
	static $inject = [
		'_',
		'$translate',
		'$state',
		'MassiaApplicationService',
		'MassiaNavigationService',
		'MassiaNavigationConfigConstant',
		'MassiaRightsService',
		'MassiaAuthService',
		'MassiaClientService',
		'$stateRegistry',
		'$timeout',
		'StocksConfigurationProduitsService',
		'$sce',
		'VersionService',
		'$transitions'
	];

	constructor(
		_,
		$translate,
		$state,
		MassiaApplicationService,
		MassiaNavigationService,
		MassiaNavigationConfigConstant,
		MassiaRightsService,
		MassiaAuthService,
		MassiaClientService,
		$stateRegistry,
		$timeout,
		StocksConfigurationProduitsService,
		$sce,
		VersionService,
		$transitions
	) {
		// Services
		this._ = _;
		this.$state = $state;
		this.$translate = $translate;
		this.MassiaApplicationService = MassiaApplicationService;
		this.MassiaNavigationService = MassiaNavigationService;
		this.MassiaNavigationConfigConstant = MassiaNavigationConfigConstant;
		this.MassiaRightsService = MassiaRightsService;
		this.MassiaAuthService = MassiaAuthService;
		this.MassiaClientService = MassiaClientService;
		this.$stateRegistry = $stateRegistry;
		this.$timeout = $timeout;
		this.stockConfigSvc = StocksConfigurationProduitsService;
		this.$sce = $sce;
		this.VersionService = VersionService;
		this.$transitions = $transitions;
		this._chatbotRouteHook = null;

		this.maxItem = 10;
		this.chatbotUrl = $sce.trustAsResourceUrl(__configuration.chatBotUrl || '');
		this.chatbotContexte = '';

		// Properties
		this.collapse = true;
		this.brand = null;
		this.search = {
			open: false,
			term: '',
			all: this.getSearchsByStates(this.$state.get()),
			navigationItems: []
		};
	}

	async $onInit() {
		await this.customInit();
		this.$stateRegistry.onStatesChanged((event) => {
			this.$timeout(() => {
				switch (event) {
					case 'deregistered':
					case 'registered':
						this.customInit();
						break;
					default:
						break;
				}
			}, 100);
		});
	}

	async customInit() {
		this.niveaux = await this.stockConfigSvc.getProduitsStocksElements();

		const activite = this.MassiaApplicationService.getApplication();
		this.search.all = this.getSearchsByStates(this.$state.get());
		try {
			this.getNavigation(activite);
		} catch (e) {
			console.error('Error while getting navigation', e);
		}
		this.getTools(activite);
		// une fois que tout est enregistré dans le service, on publie à la vue les items de navigation
		this.res = this.MassiaNavigationService.getItems();

		if (this.res) {
			this.calculStyle(this.res);
		}
	}

	$onDestroy() {
		this.MassiaNavigationService.clearItems();
	}

	getSearchsByStates(states = []) {
		return states
			.filter((state) => {
				// On ne garde dans la recherche que les états avec droits
				return (
					state &&
					state.search &&
					(state.rights === undefined ||
						this.MassiaRightsService.userHasRight(state.rights.domain, state.rights.right, state.rights.application))
				);
			})
			.map((state) => {
				return {
					name: state.name,
					search: this.$translate.instant(state.search)
				};
			});
	}

	onSearch(select) {
		this.search.term = select;

		this.search.items = this.search.all.filter(function (state) {
			return select && state.search && state.search.toLowerCase().indexOf(select.toLowerCase()) >= 0;
		}, this);
	}

	onSelect(item) {
		if (item && item.name) {
			this.$state.go(item.name);
			this.search.open = false;
		}
	}

	// Vérifie si un item appartient à l'activité courante
	isItemForCurrentActivity(item, activite) {
		// Si l'item n'a pas de droits définis, il est pour toutes les activités
		if (!item.rights || !item.rights.application) {
			return true;
		}

		// Vérifier si l'activité courante est dans la liste des applications autorisées
		const applications = item.rights.application.split(';');
		const result = applications.indexOf(activite) >= 0;

		return result;
	}

	getNavigation(activite) {
		let navigationDropdowns = angular
			.copy(this.MassiaNavigationConfigConstant.navigationMenus)
			.filter((navMenu) => {
				// On masque uniquement transport hors gestion
				if (activite != 'gestion' && navMenu.id == 'transport') {
					return false;
				}

				// Masquer les menus qui n'appartiennent pas à l'activité courante
				if (!this.isItemForCurrentActivity(navMenu, activite)) {
					return false;
				}

				return navMenu;
			})
			.map((navMenu) => {
				// On marque le menu comme désactivé si pas de droits
				const hasRights =
					navMenu.rights === undefined ||
					(navMenu.rights.domain &&
						this.MassiaRightsService.userHasRight(navMenu.rights.domain, navMenu.rights.right, navMenu.rights.application));
				const hasClientAccess =
					navMenu.clientRestriction === undefined || navMenu.clientRestriction.indexOf(this.MassiaClientService.getClient()) >= 0;

				navMenu.disabled = !hasRights || !hasClientAccess;
				return navMenu;
			});
		const user = this.MassiaAuthService.getAuthenticatedUser();
		let states = this._.chain(this.$state.get())
			.filter((state) => {
				if (!state || !state.navigation) {
					return false;
				}

				// enlever l'accès aux lieu via données en gestion
				if (activite == 'gestion' && state.navigation.menu == 'donnees_parametres_donnees' && state.rights && state.rights.domain == 'lieu') {
					return false;
				}

				// Masquer les states qui n'appartiennent pas à l'activité courante
				if (!this.isItemForCurrentActivity(state, activite)) {
					return false;
				}

				return true;
			})
			.map((state) => {
				// on enregistre le nom du state dans la configuration de la navigation
				state.navigation.sref = state.name;
				state.navigation.id = state.name;

				state.navigation.hasNoDomainMetier = false;
				// si child.rights.domain est présent, on regarde si le module est present dans le domaine metier de l'utilisateur
				if (user && user.domainesMetiers && state.rights?.domain) {
					// Si AUCUN domaine ne correspond, alors on désactive
					state.navigation.hasNoDomainMetier = user.domainesMetiers.every(
						(domaine) => domaine.code.toLowerCase() !== state.rights.domain.toLowerCase()
					);
				}

				// On marque comme désactivé si pas de droits
				const hasRights =
					state.rights === undefined ||
					(state.rights.domain && this.MassiaRightsService.userHasRight(state.rights.domain, state.rights.right, state.rights.application));
				state.navigation.disabled = !hasRights;

				// puis on ne récupère que la configuration de navigation
				return state.navigation;
			})
			.value();

		//si 2x clotures périodiques, on supprime 1 des 2
		const precloture = this._.find(states, { sref: 'stocks-preclotures.precloture-mois' });
		const cloture = this._.find(states, { sref: 'stocks-clotures.precloture-mois' });
		if (precloture && cloture) {
			states = this._.reject(states, function (item) {
				return item.sref == 'stocks-preclotures.precloture-mois';
			});
		}
		// on récupère la brand
		this.brand = this._.find(states, { position: 'brand', sref: `${this.MassiaApplicationService.getApplication()}.home` });
		// on groupe par menu afin d'ajouter rapidement les states dans les menus pré-définis
		const navigationMenuItems = this._.groupBy(states, 'menu');
		// si jamais il y a des states sans menu défini, on les ajoute à la suite de la navigation par dropdown
		this._.forEach(navigationMenuItems[undefined], (item) => {
			this.MassiaNavigationService.addItem(item, activite);
		});

		// Gestion des Rapport activité dans les stocks en menu dynamique

		let idx = navigationDropdowns.findIndex((x) => x.id === 'stocks');
		if (idx > -1) {
			// console.log('idxMenu', navigationDropdowns[idx]);
			for (const niv of this.niveaux) {
				const s = this.$state.get();
				navigationDropdowns[idx].items.push({
					id: `niv_${niv.id.elementId}`,
					header: true,
					collapse: false,
					order: 0,
					translate: `Rapport activité ${niv.label}`,
					items: s
						.filter((x) => {
							if (x.name.includes('stocks-gestion-rapport-activite.')) {
								// console.log(`NIV_${niv.id.elementId}`.toLowerCase(), x.rights.right);
								if (x.rights === undefined) return false;
								const haveRight = this.MassiaRightsService.userHasRight(`NIV_${niv.id.elementId}`.toLowerCase(), x.rights.right);
								// console.log('haveRight', haveRight);
								return haveRight;
							}
							return false;
						})
						.map((x) => {
							// puis on ne récupère que la configuration de navigation
							return {
								...x.navigation,
								sref: `${x.name}({codeDomaineParam:"${niv.id.elementId}", labelDomaineParam:"${niv.label}"})`,
								id: x.name
							};
						})
				});
			}
		}
		// console.log('navigationDropdowns', navigationDropdowns);

		// on construit la navigation
		this._.forEach(navigationDropdowns, (menu) => {
			const idsToDelete = [];
			// pour chaque sous-menu, on enregistre les states correspondant
			this._.forEach(menu.items, (submenu) => {
				// Filtrer les sous-menus en dur par activité, puis marquer comme désactivés si pas de droits
				if (submenu.items) {
					submenu.items = submenu.items.filter((sousmenudur) => {
						// Masquer si n'appartient pas à l'activité courante
						return this.isItemForCurrentActivity(sousmenudur, activite);
					});

					// Marquer les items restants comme désactivés si l'utilisateur n'a pas le droit
					this._.forEach(submenu.items, (sousmenudur) => {
						const hasRights =
							sousmenudur.rights === undefined ||
							this.MassiaRightsService.userHasRight(
								sousmenudur.rights.domain,
								sousmenudur.rights.right,
								sousmenudur.rights.application
							);
						sousmenudur.disabled = !hasRights;
					});
				}

				if (submenu.id !== undefined && navigationMenuItems[submenu.id] !== undefined) {
					// s'il existe déjà des items en dur, on les garde
					submenu.items = submenu.items.concat(navigationMenuItems[submenu.id]);
				}

				// s'il n'y a pas de state enregistrés dans ce menu
				if (submenu.items !== undefined && submenu.items.length === 0) {
					// on le prépare à la suppression
					idsToDelete.push(submenu.id);
				}

				// Vérifier si le sous-menu doit être désactivé (si tous ses enfants sont désactivés)
				// if (submenu.items !== undefined && submenu.items.length > 0) {
				// 	const allDisabled = submenu.items.every((item) => item.disabled);
				// 	if (allDisabled && submenu.disabled === undefined) {
				// 		submenu.disabled = true;
				// 	}
				// }
			});
			// une fois le traitement passé, on nettoie les menu principaux (seulement ceux qui sont vides)
			if (idsToDelete.length > 0) {
				idsToDelete.forEach((id) => this._.remove(menu.items, { id: id }));
			}
			// puis on ajoute le menu à la navigation
			if (!menu.items || menu.items.length > 0) {
				this.MassiaNavigationService.addItem(menu, activite);
			}
		});
	}

	// debug(item) {
	// 	console.log('🔥: MassiaNavigationController -> debug -> item', item);
	// }

	// Génère le tooltip pour un item désactivé (retourne du HTML sécurisé)
	getDisabledTooltip(item) {
		// Pas de tooltip si l'item n'est pas désactivé
		if (!item.disabled) {
			return null;
		}

		// Si l'item est désactivé parce que le module n'est pas activé (licence)
		const menuTranslate = this.$translate.instant(item.translate);
		if (item.hasNoDomainMetier) {
			const title = this.$translate.instant('LAYOUT.NAVIGATION.TOOLTIP.NO_MODULE_TITLE');
			const reason = this.$translate.instant('LAYOUT.NAVIGATION.TOOLTIP.NO_MODULE_REASON');
			const action = this.$translate.instant('LAYOUT.NAVIGATION.TOOLTIP.NO_MODULE_ACTION');
			return `
				<div class="nav-tooltip-content nav-tooltip-no-module">
					<div class="nav-tooltip-header">
						<span class="nav-tooltip-icon">&#128683;</span>
						<span class="nav-tooltip-title">${title}</span>
					</div>
					<div class="nav-tooltip-body">
						<p class="nav-tooltip-menu-name">${menuTranslate}</p>
						<p><strong>Raison :</strong> ${reason}</p>
						<p><strong>Action :</strong> ${action}</p>
					</div>
				</div>
			`;
		}

		// Sinon, c'est un problème de droits (profil)
		const title = this.$translate.instant('LAYOUT.NAVIGATION.TOOLTIP.NO_RIGHTS_TITLE');
		const reason = this.$translate.instant('LAYOUT.NAVIGATION.TOOLTIP.NO_RIGHTS_REASON');
		const action = this.$translate.instant('LAYOUT.NAVIGATION.TOOLTIP.NO_RIGHTS_ACTION');
		return `
			<div class="nav-tooltip-content nav-tooltip-no-rights">
				<div class="nav-tooltip-header">
					<span class="nav-tooltip-icon">&#128274;</span>
					<span class="nav-tooltip-title">${title}</span>
				</div>
				<div class="nav-tooltip-body">
					<p class="nav-tooltip-menu-name">${menuTranslate}</p>
					<p><strong>Raison :</strong> ${reason}</p>
					<p><strong>Action :</strong> ${action}</p>
				</div>
			</div>
		`;
	}

	// Vérifie si un item doit être visible

	isItemVisible(item) {
		return item.isVisible !== false;
	}

	// Vérifie si un item est désactivé (disabled ou module non activé)
	isItemDisabled(item) {
		return item.disabled || item.hasNoDomainMetier;
	}

	// Retourne le sref approprié selon l'état de l'item
	getItemSref(item) {
		return this.isItemDisabled(item) ? '' : item.sref;
	}

	// Retourne le href approprié selon l'état de l'item
	getItemHref(item) {
		return this.isItemDisabled(item) ? 'javascript:void(0)' : item.href;
	}

	// Retourne les classes CSS pour un item désactivé
	getItemClasses(item) {
		return {
			'disabled-link': item.disabled,
			'no-module': item.hasNoDomainMetier
		};
	}

	// Retourne les classes CSS pour un <li> désactivé
	getItemLiClasses(item) {
		return {
			'separator-item-sub': item.navigationCls,
			disabled: item.disabled,
			'no-module': item.hasNoDomainMetier
		};
	}

	getTools(activite) {
		const navigationTools = angular.copy(this.MassiaNavigationConfigConstant.tools);
		this.MassiaNavigationService.addItem(navigationTools, activite);
	}

	onCollapse($event, dropdown, navItem) {
		$event.stopPropagation();

		navItem.map((x) => {
			if (x.id === dropdown.id) {
				x.collapse = true;

				// Calculer la position du sous-menu pour qu'il reste visible
				this.$timeout(() => {
					const headerElement = $event.currentTarget;
					const subMenuElement = headerElement.querySelector('.sub-menu-nav');

					if (subMenuElement && headerElement) {
						const headerRect = headerElement.getBoundingClientRect();
						const subMenuHeight = subMenuElement.offsetHeight;
						const windowHeight = window.innerHeight;

						// Position par défaut: aligné avec le header
						let topPosition = 0;

						// Si le sous-menu dépasse en bas de la fenêtre
						if (headerRect.top + subMenuHeight > windowHeight) {
							// Calculer le décalage nécessaire pour le remonter
							const overflow = headerRect.top + subMenuHeight - windowHeight;
							topPosition = -overflow - 20; // -20 pour une marge de sécurité

							// S'assurer qu'on ne remonte pas trop haut (au-dessus de la navbar)
							if (headerRect.top + topPosition < 60) {
								topPosition = 60 - headerRect.top;
							}
						}

						// Appliquer le style calculé
						if (!x.ulStyle) {
							x.ulStyle = {};
						}
						x.ulStyle.top = topPosition + 'px';
					}
				}, 0);
			} else {
				x.collapse = false;
			}
		});
	}

	calculStyle(navigation) {
		navigation = angular.copy(navigation);
		for (let i = 0; i < navigation.length; i++) {
			if (navigation[i].items && navigation[i].items.length !== 0 && screen.width > 768) {
				const items = navigation[i].items;
				for (let k = 0; k < items.length; k++) {
					if (items[k].items && items[k].items.length !== 0) {
						items[k].ulStyle = {
							display: 'grid',
							'grid-auto-flow': 'column',
							'grid-template-rows': 'repeat(' + this.maxItem + ', auto)'
						};
					}
				}
			}
		}
		this.navigationItems = navigation;
	}

	closeAllCollapsed(array) {
		array.map((e) => (e.collapse = false));
	}

	onClose(item, drop) {
		const elem = document.getElementById(item.id);
		elem.click();

		setTimeout(() => {
			drop.collapse = false;
		}, 100);
	}

	startDragChatbot(event) {
		const panel = document.getElementById('chatbot-panel');
		if (!panel) return;

		// Convertir bottom/right en top/left pour pouvoir déplacer librement
		const rect = panel.getBoundingClientRect();
		panel.style.top = rect.top + 'px';
		panel.style.left = rect.left + 'px';
		panel.style.bottom = 'auto';
		panel.style.right = 'auto';

		const startX = event.clientX - rect.left;
		const startY = event.clientY - rect.top;

		const onMouseMove = (e) => {
			panel.style.left = e.clientX - startX + 'px';
			panel.style.top = e.clientY - startY + 'px';
		};
		const onMouseUp = () => {
			document.removeEventListener('mousemove', onMouseMove);
			document.removeEventListener('mouseup', onMouseUp);
		};
		document.addEventListener('mousemove', onMouseMove);
		document.addEventListener('mouseup', onMouseUp);
	}

	toggleChatbot() {
		this.chatbotOpen = !this.chatbotOpen;
		if (this.chatbotOpen) {
			this.$timeout(() => this.sendChatbotContext(), 500);
			this._chatbotRouteHook = this.$transitions.onSuccess({}, () => this.sendChatbotContext());
		} else {
			if (this._chatbotRouteHook) {
				this._chatbotRouteHook();
				this._chatbotRouteHook = null;
			}
		}
	}

	sendChatbotContext() {
		const iframe = document.getElementById('chatbot-iframe');
		if (iframe && iframe.contentWindow) {
			const currentUser = this.MassiaAuthService.getAuthenticatedUser();
			this.chatbotContexte =
				'app:' + __configuration.defaultApp + ';' + 'licence:' + __configuration.licenceGest + ';' + 'login:' + currentUser.login + ';';

			this.VersionService.getVersion().then((version) => {
				this.chatbotContexte += 'version:' + version + ';';

				if (this.$state.current.ncyBreadcrumb && this.$state.current.ncyBreadcrumb.label)
					this.chatbotContexte += 'route:' + this.$translate.instant(this.$state.current.ncyBreadcrumb.label) + ';';
				else if (this.$state.current.name === 'gestion.home') this.chatbotContexte += 'route:' + this.$translate.instant('HOME.TITLE') + ';';
				else if (this.$state.current.name) this.chatbotContexte += 'route:' + this.$state.current.name.split('.')[0] + ';';

				console.log('🚀 ~ MassiaNavigationController ~ sendChatbotContext ~ this.chatbotContexte:', this.chatbotContexte);
				iframe.contentWindow.postMessage({ type: 'massia_context', context: this.chatbotContexte }, __configuration.chatBotUrl || '*');
			});
		}
	}

	async changeApplication(menu) {
		const client = this.MassiaClientService.getClient();
		if (client && menu['href_' + client]) {
			window.location.href = menu['href_' + client];
		} else {
			/* let pathName = '';
			const paths = window.location.pathname.split('/');
			for (let i = 0; i < paths.length; i++) {
				if (paths[i] && !paths[i].endsWith('.html')) {
					pathName += paths[i] + '/';
				}
			} */

			const application = menu.href.replace('.html', '');
			this.MassiaNavigationService.clearItems();
			this.$state.go(`${application}.home`);
			this.MassiaApplicationService.setApplication(application);
			await this.MassiaAuthService.authenticateUser(application);
			this.$onInit();
			/* window.location.href = window.location.origin + '/' + pathName + menu.href; */
		}
	}
}
